import Link from 'next/link';
import NavLink from 'next/link';
import PropTypes from 'prop-types';

import LogoSvg from '@/public/images/logo.svg';
import WhiteLogoSvg from '@/public/images/whiteLoogo.svg';
import useIsMobile from '@/src/hooks/useIsMobile';
import useRoutePaths from '@/src/hooks/useRoutePaths';
import {useTheme} from '@/src/hooks/useTheme';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, SectionContainer, Text} from '../../../ui';
import css from '../styles/Header.module.css';

const Header = ({withSignInButton}) => {
  const {isMaxWidth900} = useIsMobile();
  const {SIGN_IN_ROUTE, INDEX_ROUTE} = useRoutePaths();
  const {isDarkMode} = useTheme();

  return (
    <header className={css.header}>
      <SectionContainer>
        <div className={css.headerInner}>
          <NavLink href={INDEX_ROUTE.getLink()}>
            <a className={css.logo} aria-label={`medyoucate logo`}>
              {isDarkMode ? <WhiteLogoSvg /> : <LogoSvg />}
            </a>
          </NavLink>

          {withSignInButton && !isMaxWidth900 && (
            <div className={css.rightSide}>
              <Text color={Text.COLOR.GREY} fontSize={Text.FONT_SIZE.SIZE_17}>
                <TextLocal id="userType.has-account-q" />
              </Text>
              <div className={css.singInWrapper}>
                <Link href={SIGN_IN_ROUTE.getLink()}>
                  <a>
                    <Button
                      height={Button.HEIGHT.SMALL}
                      color={Button.COLOR.SECONDARY}
                    >
                      <TextLocal id="userType.sign-in" />
                    </Button>
                  </a>
                </Link>
              </div>
            </div>
          )}
        </div>
      </SectionContainer>
    </header>
  );
};

Header.propTypes = {
  withSignInButton: PropTypes.bool.isRequired,
};

export default Header;
